// Constants for the Crude HPS List module.
//
// No backend contract exists yet for this screen (nothing under
// .claude/api-contract/ mentions HPS) — runs entirely on dummy data, mirroring
// how Crude Category / Procurement were built ahead of their contracts.
//
// Per task 6 (hps-list.md): this list spans the whole procurement pipeline —
// a record's Main Status is whichever stage it currently sits in (Planning,
// Procurement, Tender Opening, ... HPS); HPS Status is the sub-status WITHIN
// the HPS stage specifically and only means something once Main Status is HPS.

export const MAIN_STATUS = {
  PLANNING: 'Planning',
  PROCUREMENT: 'Procurement',
  TENDER_OPENING: 'Tender Opening',
  HPS: 'HPS',
};

export const MAIN_STATUS_BADGE = {
  [MAIN_STATUS.PLANNING]: 'secondary',
  [MAIN_STATUS.PROCUREMENT]: 'primary',
  [MAIN_STATUS.TENDER_OPENING]: 'info',
  [MAIN_STATUS.HPS]: 'warning',
};

// Sub-status within the HPS stage. Only populated once mainStatus === HPS;
// every other stage shows NOT_AVAILABLE ("HPS not reached yet").
export const HPS_STATUS = {
  NOT_AVAILABLE: 'Not Available',
  WAITING_FC_REVIEW: 'Waiting for HPS FC Review',
  WAITING_APPROVAL: 'Waiting for HPS Approval',
  COMPLETED: 'HPS Completed',
};

export const HPS_STATUS_BADGE = {
  [HPS_STATUS.NOT_AVAILABLE]: 'secondary',
  [HPS_STATUS.WAITING_FC_REVIEW]: 'warning',
  [HPS_STATUS.WAITING_APPROVAL]: 'info',
  [HPS_STATUS.COMPLETED]: 'success',
};

// Order + icon for the horizontal summary cards (one per HPS Status, per DOD
// item 7: "jumlah request HPS sesuai dengan status nya pada setiap card").
export const HPS_STATUS_CARDS = [
  {
    status: HPS_STATUS.WAITING_FC_REVIEW,
    icon: 'ri-time-line',
    color: 'warning',
  },
  {
    status: HPS_STATUS.WAITING_APPROVAL,
    icon: 'ri-shield-check-line',
    color: 'info',
  },
  {
    status: HPS_STATUS.COMPLETED,
    icon: 'ri-checkbox-circle-line',
    color: 'success',
  },
  {
    status: HPS_STATUS.NOT_AVAILABLE,
    icon: 'ri-forbid-line',
    color: 'secondary',
  },
];

// Where "View Detail" navigates, keyed by Main Status. Stages that don't have
// a built detail page yet resolve to `null` — the caller falls back to an
// info toast instead of navigating (same incremental-build pattern used by
// ProcurementView while Tender Opening/HPS detail pages don't exist).
export const DETAIL_ROUTE_BY_MAIN_STATUS = {
  [MAIN_STATUS.PLANNING]: id => `/crude/planning/dtl/${id}`,
  [MAIN_STATUS.PROCUREMENT]: id => `/crude/procurement/dtl/${id}`,
};

export const resolveDetailRoute = (mainStatus, id) => {
  const build = DETAIL_ROUTE_BY_MAIN_STATUS[mainStatus];
  return build ? build(id) : null;
};
